import React from "react";
import Link from "next/link";
import Layout from "../components/Layout";
import Scrollspy from "react-scrollspy";
import Scroll from "./Scroll";
import LeadCaptureForm from "../components/LeadCaptureForm";
// import { isBrowser } from "react-device-detect";
import { isBrowser } from "../components/DeviceType";
import PrivacyPolicyRoute from "../components/Common/PrivacyPolicyRoute";
import CopyRightNote from "../components/Common/CopyrightNote";

declare var drift: any;

const GetQuote = () => {
 
  const onClickLiveChat = () => {
    if(isBrowser){
      if (drift) {
        drift.api.openChat();
        drift.api.startInteraction({ interactionId: 287390 });
      }
    }
  };

  return (
    <Layout title="Get Your Free Estimate | Solar Quote">
      <section className="grid place-center home landing-v1 pt-24">
        <div className="p-4 container m-auto grid place-center">
          <div className="grid grid-cols-1 2md:grid-cols-2 gap-4 py-8 banner-height place-center items-center justify-center">
            {/* <div className="2md:py-8 2md:px-14"> */}
            <div className="2md:py-8 2md:px-8 xl:px-14">
              <h1 className="uppercase text-4xl xxs:text-6xl 2xl:text-7xl font-primaryBold text-white lg:max-w-xl md:max-w-lg">
                buy how you
                <span className="text-yellow-500 font-primaryBold">
                  {" "}
                  want to buy
                </span>
              </h1>
              <p className="text-base xxs:text-xl 2xl:text-2xl text-gray-200 py-3 lg:max-w-xl md:max-w-lg">
                Stop letting solar companies dictate how you should purchase
                your solar. With Solar Quote you are in command. Purchase solar
                how, where and when you want. There has never been a better or
                easier time to switch to solar.
              </p>

              <div className="flex flex-col text-gray-200">
                <div className="flex flex-row py-2 pt-4">
                  <div className="w-12 xxs:w-auto">
                    <img
                      src="./images/estimate.png"
                      className="w-9 h-9 object-contain"
                    />
                  </div>
                  <div className="w-full xxs:w-auto pl-2 xxs:px-4">
                    <h4 className="sm:text-lg 2xl:text-xl font-primaryMedium line-height uppercase">
                      Get an instant estimate
                    </h4>
                    <p className="text-sm xxs:text-base 2xl:text-lg">
                      By sharing your electricity bill amount and address
                    </p>
                  </div>
                </div>
                <div className="flex flex-row py-2">
                  <div className="">
                    <svg
                      className="w-10 h-10 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      ></path>
                    </svg>
                  </div>
                  <div
                    onClick={() => {
                      onClickLiveChat();
                    }}
                    className="cursor-pointer px-4"
                  >
                    <h4 className="uppercase text-sm xxs:text-lg 2xl:text-2xl font-primaryMedium ">
                      live chat
                    </h4>
                    <p className="text-xs xxs:text-base 2xl:text-xl">
                      Chat directly with our reps
                    </p>
                  </div>
                </div>
                <div className="flex flex-row py-2">
                  <div>
                    <svg
                      className="w-10 h-10 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                      ></path>
                    </svg>{" "}
                  </div>
                  <Link href="tel:385-367-5974">
                    <div className="cursor-pointer px-4">
                      <h4 className="uppercase text-sm xxs:text-lg 2xl:text-2xl font-primaryMedium ">
                        Over the phone
                      </h4>
                      <p className="text-xs xxs:text-base 2xl:text-xl">
                        Communicate via phone
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="flex flex-row py-2">
                  <div>
                    <svg
                      className="w-10 h-10 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                      ></path>
                    </svg>
                  </div>
                  <div className="px-4">
                    <h4 className="uppercase text-sm xxs:text-lg 2xl:text-2xl font-primaryMedium ">
                      in-home consultation
                    </h4>
                    <p className="text-xs xxs:text-base 2xl:text-xl">
                      Come and meet with you
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* form page1 */}
            <LeadCaptureForm></LeadCaptureForm>
          </div>
        </div>
        {/* main end */}
      </section>

      {/* page2 */}
      <section className="bg-white py-8 sm:pr-20 pr-4 ">
        <div className="sm:py-8 grid grid-cols-1 lg:grid-cols-2 gap-3">
          <div className="sm:my-6 mb-0">
            <img
              src="./images/img1.png"
              className="object-contain image-responsive"
            />
          </div>
          <div className="py-4 lg:px-0 px-6">
            <h1 className="pb-4 sm:pb-12 text-3xl xxs:text-4xl 2xl:text-6xl tracking-wide font-primaryMedium">
              Which way is <span className="text-primary">right</span> for you?
            </h1>
            <div>
              <div className="grid sm:auto-cols-auto grid-cols-1 gap-4">
                <div className="">
                  <h2 className="text-primary text-lg xxs:text-2xl 2xl:text-4xl">
                    Live Chat
                  </h2>
                  <div className="border border-primary my-2 w-20 mb-4"> </div>
                  <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                    Have questions about getting solar for your home? Chat
                    directly with one of our knowledgeable representatives via
                    our online chat. They will answer any questions you have and
                    provide you with a custom quote within minutes.
                  </p>
                </div>
                <div className="">
                  <h2 className="text-primary text-lg xxs:text-2xl 2xl:text-4xl">
                    Over the Phone
                  </h2>
                  <div className="border border-primary my-2 w-20 mb-4"> </div>
                  <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                    More comfortable talking over the phone? Give us a call at
                    385-367-5974 and one of our representatives will talk to
                    you about how we can reduce your energy costs. They will
                    talk through your needs and provide you a quote for solar in
                    minutes
                  </p>
                </div>
                <div className="">
                  <h2 className="text-primary text-lg xxs:text-2xl 2xl:text-4xl">
                    In-Home Consultation
                  </h2>
                  <div className="border border-primary my-2 w-20 mb-4"> </div>
                  <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                    For those that prefer an in-home consultation, we have reps
                    standing by to come and meet with you in your home. We will
                    schedule and appointment with you and have our solar
                    representatives come to your home to discuss your wants and
                    needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* page3 */}
      <section className="bg-white">
        <div className="container m-auto md:px-4 px-6">
          <div className="text-center sm:pb-0 pb-4 lg:max-w-xl xl:max-w-3xl m-auto">
            <h1 className="text-3xl xxs:text-4xl 2xl:text-6xl tracking-wide font-primaryMedium">
              Take back control of your{" "}
              <span className="text-primary"> energy </span> with{" "}
              <span className="text-primary"> confidence</span>
            </h1>
          </div>

          <div className="grid md:grid-cols-3 md:gap-10 lg:gap-14 sm:pt-10 py-4 lg:mx-14 grid-cols-1 gap-4">
            <div className="shadow-md mb-4">
              <div className="">
                <img
                  src="./images/convenience.png"
                  alt="img"
                  className="object-cover w-full"
                />
                <h2 className="md:p-6 md:py-4 p-2 text-gray-800 text-xl xxs:text-2xl 2xl:text-4xl font-primaryMedium">
                  Convenience
                </h2>
                <p className="lg:px-6 md:p-6 pt-2 p-3 md:pt-0 pb-8 text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                  We believe in convenience. From purchasing, to the
                  installation and beyond. We will do all the heavy lifting for
                  you so you can sit back in relax. Even after your system has
                  been installed, you can manage your solar production using
                  your phone or smart device.
                </p>
              </div>
            </div>
            <div className="shadow-md mb-4">
              <div className="">
                <img
                  src="./images/customized.png"
                  alt="img"
                  className="object-cover w-full"
                />
                <h2 className="md:p-6 md:py-4 p-2 text-gray-800 text-xl xxs:text-2xl 2xl:text-4xl font-primaryMedium">
                  Customized
                </h2>
                <p className="lg:px-6 md:p-6 pt-2 p-3 md:pt-0 pb-8 text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                  Everyone has different wants and needs. We are here to help
                  you with yours. We will set up a custom system design that
                  fits your home and your needs.
                </p>
              </div>
            </div>
            <div className="shadow-md mb-4">
              <div className="">
                <img
                  src="./images/reliable.png"
                  alt="img"
                  className="object-cover w-full"
                />
                <h2 className="md:p-6 md:py-4 p-2 text-gray-800 text-xl xxs:text-2xl 2xl:text-4xl font-primaryMedium">
                  Reliable
                </h2>
                <p className="lg:px-6 md:p-6 pt-2 p-3 md:pt-0 pb-8 text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                  Reliability is our bread and butter. With top notch install
                  crews and quality products we stand by our work. That is why
                  we provide up to 25-year warranties on our products.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* page4 */}
      <section className="bg-white py-8 md:py-0">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 lg:gap-4 grid-cols-1 pr-0 md:p-10 p-6 md:pr-0">
          <div className="md:p-14 pt-4">
            <div className="">
              <div>
                <h1 className="text-3xl xxs:text-4xl 2xl:text-6xl tracking-wide font-primaryMedium capitalize ">
                  <span className="text-primary">why</span> go solar?
                </h1>
              </div>
              <div className="container md:m-auto md:pt-12 md:px-6 px-2 pt-10">
                <div className="flex flex-row">
                  <div className="md:pr-8 pr-4">
                    <img
                      src="./images/money1.png"
                      alt="img"
                      width="200"
                      className="image-responsive w-32 sm:w-48"
                    />
                  </div>
                  <div className="pb-8">
                    <h2 className="text-xl 2xl:text-3xl text-gray-800 font-primaryMedium">
                      Save Money
                    </h2>
                    <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                      Switching to solar power will save you money. Utility
                      rates are high and continue to rise. With different
                      finance options Solar Quote has the ability to bring your
                      monthly bill down and save you money.
                    </p>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div className="md:pr-8 pr-4">
                    <img
                      src="./images/bill1.png"
                      alt="img"
                      width="200"
                      className="image-responsive w-32 sm:w-48"
                    />
                  </div>
                  <div className="pb-8">
                    <h2 className="text-xl 2xl:text-3xl text-gray-800 font-primaryMedium">
                      Gain Freedom
                    </h2>
                    <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                      Solar provides you with the freedom to move away from your
                      high utility bills, by giving you a way to get clean
                      renewable energy at a fraction of the cost of traditional
                      power. Take back your control with Solar Quote today.
                    </p>
                  </div>
                </div>
                <div className="flex flex-row">
                  <div className="md:pr-8 pr-4">
                    <img
                      src="./images/saving1.png"
                      alt="img"
                      width="200"
                      className="image-responsive w-32 sm:w-48"
                    />
                  </div>
                  <div className="">
                    <h2 className="text-xl 2xl:text-3xl text-gray-800 font-primaryMedium">
                      Take care of what you love
                    </h2>
                    <p className="text-gray-500 font-primaryMedium text-base 2xl:text-xl">
                      Solar not only protects the planet and improves the
                      quality of life for generations to come, but it also
                      allows you to protect your family. When coupled with a
                      home battery you are able to protect what maters most when
                      the grid goes down and people are without power.
                    </p>

                    <Scrollspy
                      items={["quote-form"]}
                      className="scrollContentData "
                      currentClassName="scrollContentData "
                    >
                      <Scroll type="id" element="quote-form">
                        <a
                          href=""
                          className="text-primary border-2 inline-block border-primary font-primaryMedium px-7 py-3 my-8 text-base 2xl:text-xl"
                        >
                          Get Started
                        </a>
                      </Scroll>
                    </Scrollspy>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:py-8 py-0">
            <img
              src="./images/why.png"
              className="object-contain image-responsive"
            />
          </div>
        </div>
      </section>
      {/* page5 */}
      <section>
        <div className="container m-auto lg:p-10 md:p-4">
          <h1 className=" text-3xl xxs:text-4xl 2xl:text-6xl text-center tracking-wide font-primaryMedium p-4">
            <span className="text-primary">Products </span> and Services
          </h1>
          <div className="lg:mx-20 lg:px-10 px-6 md:mx-4 md:px-4">
            <div className="grid md:grid-cols-2 md:gap-4 grid-cols-1 gap-2">
              <div className="md:p-8">
                <div className="bg-white p-8">
                  <img
                    src="./images/solar-panel.png"
                    className="object-contain bg-white m-auto"
                  />
                </div>
              </div>
              <div className="grid place-content-center md:p-8">
                <div className="md:p-8">
                  <h2 className="text-2xl xxs:text-3xl 2xl:text-4xl text-gray-800 font-primaryMedium md:pt-8 pt-4">
                    Solar for your home
                  </h2>
                  <p className="text-gray-500 font-primaryMedium md:p-1 text-base 2xl:text-xl">
                    Depend less on your local utility and create your own
                    renewable energy.
                  </p>

                  <Scrollspy
                    items={["quote-form"]}
                    className="scrollContentData"
                    currentClassName="scrollContentData"
                  >
                    <Scroll type="id" element="quote-form">
                      <a
                        href=""
                        className="text-primary border-2 border-primary inline-block font-primaryMedium px-5 py-1 my-4 text-base 2xl:text-xl"
                      >
                        Get Quote
                      </a>
                    </Scroll>
                  </Scrollspy>
                </div>
              </div>
            </div>

            <div className="my-6 md:my-0 flex flex-col-reverse md:grid md:grid-cols-2 md:gap-4 grid-cols-1 gap-2">
              <div className="grid place-content-center md:p-8">
                <div className="md:p-8">
                  <h2 className="text-2xl xxs:text-3xl 2xl:text-4xl text-gray-800 font-primaryMedium md:pt-8 pt-4">
                    Home Battery Storage
                  </h2>
                  <p className="text-gray-500 font-primaryMedium md:p-1 text-base 2xl:text-xl">
                    Store unused energy for emergencies or peak rate times for
                    additional cost savings.
                  </p>
                  <Scrollspy
                    items={["quote-form"]}
                    className="scrollContentData"
                    currentClassName="scrollContentData"
                  >
                    <Scroll type="id" element="quote-form">
                      <a
                        href=""
                        className="text-primary border-2 border-primary inline-block font-primaryMedium px-5 py-1 my-4 text-base 2xl:text-xl"
                      >
                        Get Quote
                      </a>
                    </Scroll>
                  </Scrollspy>
                </div>
              </div>
              <div className="md:p-8">
                <div className="bg-white p-8">
                  <img
                    src="./images/battery1.png"
                    className="object-contain bg-white m-auto"
                  />
                </div>
              </div>
            </div>

            {/* <div className="grid md:grid-cols-2 md:gap-4 grid-cols-1 gap-2">
            <div className="md:p-8">
            <div className="bg-white p-8">
              <img
                src="./images/charger.png"
                className="object-contain bg-white m-auto"
              /></div>
            </div>
            <div className="grid place-content-center md:p-8">
              <div className="md:p-8">
              <h2 className="text-2xl xxs:text-3xl 2xl:text-4xl text-gray-800 font-primaryMedium md:pt-8 pt-4">
              Electric Vehicle Chargers
              </h2>
              <p className="text-gray-500 font-primaryMedium md:p-1 text-base 2xl:text-xl">
              Provide a faster and smarter charge to your EV with our
                selection of vehicle chargers.
              </p>
              <Scrollspy items={['quote-form']} className="scrollContentData" currentClassName="scrollContentData">
          <Scroll type="id" element="quote-form">
            <a
              href=""
              className="text-primary border-2 border-primary inline-block font-primaryMedium px-5 py-1 my-4 text-base 2xl:text-xl"
            >
              Get Quote
            </a>
          </Scroll>
        </Scrollspy>
            </div>
            </div>
          </div> */}
          </div>
        </div>
      </section>

      <footer>
        <div className="text-center bg-white">
          <p className="p-6 text-gray-500 font-primaryMedium text-base 2xl:text-xl">
            <CopyRightNote/> |&nbsp;
            <PrivacyPolicyRoute className="text-gray-900 cursor-pointer " />
           
            &nbsp;
            <span className="text-gray-900 ">385-367-5974</span>
          </p>
        </div>
      </footer>
    </Layout>
  );
};

export default GetQuote;
